const TetherCnt = {
  symbol: "SUSHI",
  name: "sushiSwap",
  meta: {
    title: "Buy sushiSwap | Sell sushiSwap | sushiSwap prices and charts",
    description:
      "Sushi swap is one of the most successful defy protocols and has gained a lot of popularity. Now sell and buy swap sushi in coinnik Market directly and without intermediaries.",
    keywords: "SushiSwap, buy sushiSwap, sell sushiSwap, sushiSwap price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه سوشی سواپ بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید سوشی سواپ کنید. قیمت سوشی سواپ در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول سوشی سواپ کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای نگهداری سوشی سواپ این کیف پول‌ها انتخاب‌های مناسبی هستند: کیف پول متامسک (Metamask)، کیف پول سخت افزاری لجر (Ledger)، کیف پول اکسودوس (Exodus)، کیف پول تراست (Trust Wallet) و کیف پول کوینومی (Coinomi)",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین‌نیک مارکت امکان نگهداری توکن سوشی وجود دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "بله، در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید توکن سوشی را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا سوشی سواپ ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "سوشی سواپ با مدیریت جدید، غذاهای خوشمزه‌تری را نسبت به گذشته ارائه می‌دهد. بلندپروازی و تلاش توسعه‌دهندگان اصلی و جامعه آن تحسین برانگیز است و می‌تواند برای پیشبرد این پروژه در آینده کافی باشد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy sushiSwap",
      answer:
        "In coinnik Market trading platform, you can buy swap sushi with Shetab member bank card and the lowest fee. The price of sushi swap in coinnik Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best sushiSwap wallet?",
      answer: "SushiSwap_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a sushiSwap at coinnik Market?",
      answer: "Keep_sushiSwap_description",
      id: "toggler3",
    },
    {
      question: "Is sushiSwap worth the investment?",
      answer: "SushiSwap_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about sushi",
        subTitle: "What is sushiSwap?",
        content: "SushiSwap_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of sushiSwap",
        content: "SushiSwap_history_description",
        btnTitle: "Buy and sell sushiSwap",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell sushiSwap without intermediaries in coinnik Market",
        subTitle: "Buy sushiSwap",
        content: "Buy_sushiSwap_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell sushiSwap",
        content: "Sell_sushiSwap_description",
        btnTitle: "Buy and sell sushiSwap",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest sushiSwap analysis on the blog",
  informationTitle: "sushiSwap market statistics and information",
};

export default TetherCnt;
